import type { GraphQLClient } from 'graphql-request';
import type * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Address: string;
  AssetId: string;
  BlockId: string;
  Bytes32: string;
  ContractId: string;
  HexString: string;
  MessageId: any;
  Salt: string;
  Signature: any;
  Tai64Timestamp: any;
  TransactionId: string;
  TxPointer: any;
  U64: string;
  UtxoId: string;
};

export type GqlBalance = {
  __typename: 'Balance';
  amount: Scalars['U64'];
  assetId: Scalars['AssetId'];
  owner: Scalars['Address'];
};

export type GqlBalanceConnection = {
  __typename: 'BalanceConnection';
  /** A list of edges. */
  edges: Array<GqlBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<GqlBalance>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlBalanceEdge = {
  __typename: 'BalanceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: GqlBalance;
};

export type GqlBalanceFilterInput = {
  /** Filter coins based on the `owner` field */
  owner: Scalars['Address'];
};

export type GqlBlock = {
  __typename: 'Block';
  consensus: GqlConsensus;
  header: GqlHeader;
  id: Scalars['BlockId'];
  transactions: Array<GqlTransaction>;
};

export type GqlBlockConnection = {
  __typename: 'BlockConnection';
  /** A list of edges. */
  edges: Array<GqlBlockEdge>;
  /** A list of nodes. */
  nodes: Array<GqlBlock>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlBlockEdge = {
  __typename: 'BlockEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: GqlBlock;
};

export type GqlBreakpoint = {
  contract: Scalars['ContractId'];
  pc: Scalars['U64'];
};

export type GqlChainInfo = {
  __typename: 'ChainInfo';
  baseChainHeight: Scalars['U64'];
  consensusParameters: GqlConsensusParameters;
  latestBlock: GqlBlock;
  name: Scalars['String'];
  peerCount: Scalars['Int'];
};

export type GqlChangeOutput = {
  __typename: 'ChangeOutput';
  amount: Scalars['U64'];
  assetId: Scalars['AssetId'];
  to: Scalars['Address'];
};

export type GqlCoin = {
  __typename: 'Coin';
  amount: Scalars['U64'];
  assetId: Scalars['AssetId'];
  blockCreated: Scalars['U64'];
  maturity: Scalars['U64'];
  owner: Scalars['Address'];
  status: GqlCoinStatus;
  utxoId: Scalars['UtxoId'];
};

export type GqlCoinConnection = {
  __typename: 'CoinConnection';
  /** A list of edges. */
  edges: Array<GqlCoinEdge>;
  /** A list of nodes. */
  nodes: Array<GqlCoin>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlCoinEdge = {
  __typename: 'CoinEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: GqlCoin;
};

export type GqlCoinFilterInput = {
  /** Returns coins only with `asset_id`. */
  assetId?: InputMaybe<Scalars['AssetId']>;
  /** Returns coins owned by the `owner`. */
  owner: Scalars['Address'];
};

export type GqlCoinOutput = {
  __typename: 'CoinOutput';
  amount: Scalars['U64'];
  assetId: Scalars['AssetId'];
  to: Scalars['Address'];
};

export enum GqlCoinStatus {
  Spent = 'SPENT',
  Unspent = 'UNSPENT',
}

export type GqlConsensus = GqlGenesis | GqlPoAConsensus;

export type GqlConsensusParameters = {
  __typename: 'ConsensusParameters';
  contractMaxSize: Scalars['U64'];
  gasPerByte: Scalars['U64'];
  gasPriceFactor: Scalars['U64'];
  maxGasPerTx: Scalars['U64'];
  maxInputs: Scalars['U64'];
  maxMessageDataLength: Scalars['U64'];
  maxOutputs: Scalars['U64'];
  maxPredicateDataLength: Scalars['U64'];
  maxPredicateLength: Scalars['U64'];
  maxScriptDataLength: Scalars['U64'];
  maxScriptLength: Scalars['U64'];
  maxStorageSlots: Scalars['U64'];
  maxWitnesses: Scalars['U64'];
};

export type GqlContract = {
  __typename: 'Contract';
  bytecode: Scalars['HexString'];
  id: Scalars['ContractId'];
  salt: Scalars['Salt'];
};

export type GqlContractBalance = {
  __typename: 'ContractBalance';
  amount: Scalars['U64'];
  assetId: Scalars['AssetId'];
  contract: Scalars['ContractId'];
};

export type GqlContractBalanceConnection = {
  __typename: 'ContractBalanceConnection';
  /** A list of edges. */
  edges: Array<GqlContractBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<GqlContractBalance>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlContractBalanceEdge = {
  __typename: 'ContractBalanceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: GqlContractBalance;
};

export type GqlContractBalanceFilterInput = {
  /** Filter assets based on the `contractId` field */
  contract: Scalars['ContractId'];
};

export type GqlContractCreated = {
  __typename: 'ContractCreated';
  contract: GqlContract;
  stateRoot: Scalars['Bytes32'];
};

export type GqlContractOutput = {
  __typename: 'ContractOutput';
  balanceRoot: Scalars['Bytes32'];
  inputIndex: Scalars['Int'];
  stateRoot: Scalars['Bytes32'];
};

export type GqlExcludeInput = {
  /** Messages to exclude from the selection. */
  messages: Array<Scalars['MessageId']>;
  /** Utxos to exclude from the selection. */
  utxos: Array<Scalars['UtxoId']>;
};

export type GqlFailureStatus = {
  __typename: 'FailureStatus';
  block: GqlBlock;
  programState?: Maybe<GqlProgramState>;
  reason: Scalars['String'];
  time: Scalars['Tai64Timestamp'];
};

export type GqlGenesis = {
  __typename: 'Genesis';
  /**
   * The chain configs define what consensus type to use, what settlement layer to use,
   * rules of block validity, etc.
   */
  chainConfigHash: Scalars['Bytes32'];
  /** The Binary Merkle Tree root of all genesis coins. */
  coinsRoot: Scalars['Bytes32'];
  /** The Binary Merkle Tree root of state, balances, contracts code hash of each contract. */
  contractsRoot: Scalars['Bytes32'];
  /** The Binary Merkle Tree root of all genesis messages. */
  messagesRoot: Scalars['Bytes32'];
};

export type GqlHeader = {
  __typename: 'Header';
  /** Hash of the application header. */
  applicationHash: Scalars['Bytes32'];
  /** The layer 1 height of messages and events to include since the last layer 1 block number. */
  daHeight: Scalars['U64'];
  /** Fuel block height. */
  height: Scalars['U64'];
  /** Hash of the header */
  id: Scalars['BlockId'];
  /** Number of output messages in this block. */
  outputMessagesCount: Scalars['U64'];
  /** Merkle root of messages in this block. */
  outputMessagesRoot: Scalars['Bytes32'];
  /** Merkle root of all previous block header hashes. */
  prevRoot: Scalars['Bytes32'];
  /** The block producer time. */
  time: Scalars['Tai64Timestamp'];
  /** Number of transactions in this block. */
  transactionsCount: Scalars['U64'];
  /** Merkle root of transactions. */
  transactionsRoot: Scalars['Bytes32'];
};

export type GqlInput = GqlInputCoin | GqlInputContract | GqlInputMessage;

export type GqlInputCoin = {
  __typename: 'InputCoin';
  amount: Scalars['U64'];
  assetId: Scalars['AssetId'];
  maturity: Scalars['U64'];
  owner: Scalars['Address'];
  predicate: Scalars['HexString'];
  predicateData: Scalars['HexString'];
  txPointer: Scalars['TxPointer'];
  utxoId: Scalars['UtxoId'];
  witnessIndex: Scalars['Int'];
};

export type GqlInputContract = {
  __typename: 'InputContract';
  balanceRoot: Scalars['Bytes32'];
  contract: GqlContract;
  stateRoot: Scalars['Bytes32'];
  txPointer: Scalars['TxPointer'];
  utxoId: Scalars['UtxoId'];
};

export type GqlInputMessage = {
  __typename: 'InputMessage';
  amount: Scalars['U64'];
  data: Scalars['HexString'];
  messageId: Scalars['MessageId'];
  nonce: Scalars['U64'];
  predicate: Scalars['HexString'];
  predicateData: Scalars['HexString'];
  recipient: Scalars['Address'];
  sender: Scalars['Address'];
  witnessIndex: Scalars['Int'];
};

export type GqlMessage = {
  __typename: 'Message';
  amount: Scalars['U64'];
  daHeight: Scalars['U64'];
  data: Scalars['HexString'];
  messageId: Scalars['MessageId'];
  nonce: Scalars['U64'];
  recipient: Scalars['Address'];
  sender: Scalars['Address'];
  status: GqlMessageStatus;
};

export type GqlMessageConnection = {
  __typename: 'MessageConnection';
  /** A list of edges. */
  edges: Array<GqlMessageEdge>;
  /** A list of nodes. */
  nodes: Array<GqlMessage>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlMessageEdge = {
  __typename: 'MessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: GqlMessage;
};

export type GqlMessageOutput = {
  __typename: 'MessageOutput';
  amount: Scalars['U64'];
  recipient: Scalars['Address'];
};

export type GqlMessageProof = {
  __typename: 'MessageProof';
  amount: Scalars['U64'];
  data: Scalars['HexString'];
  header: GqlHeader;
  nonce: Scalars['Bytes32'];
  proofIndex: Scalars['U64'];
  proofSet: Array<Scalars['Bytes32']>;
  recipient: Scalars['Address'];
  sender: Scalars['Address'];
  signature: Scalars['Signature'];
};

export enum GqlMessageStatus {
  Spent = 'SPENT',
  Unspent = 'UNSPENT',
}

export type GqlMutation = {
  __typename: 'Mutation';
  continueTx: GqlRunResult;
  /** Execute a dry-run of the transaction using a fork of current state, no changes are committed. */
  dryRun: Array<GqlReceipt>;
  endSession: Scalars['Boolean'];
  execute: Scalars['Boolean'];
  produceBlocks: Scalars['U64'];
  reset: Scalars['Boolean'];
  setBreakpoint: Scalars['Boolean'];
  setSingleStepping: Scalars['Boolean'];
  startSession: Scalars['ID'];
  startTx: GqlRunResult;
  /** Submits transaction to the txpool */
  submit: GqlTransaction;
};

export type GqlMutationContinueTxArgs = {
  id: Scalars['ID'];
};

export type GqlMutationDryRunArgs = {
  tx: Scalars['HexString'];
  utxoValidation?: InputMaybe<Scalars['Boolean']>;
};

export type GqlMutationEndSessionArgs = {
  id: Scalars['ID'];
};

export type GqlMutationExecuteArgs = {
  id: Scalars['ID'];
  op: Scalars['String'];
};

export type GqlMutationProduceBlocksArgs = {
  blocksToProduce: Scalars['U64'];
  time?: InputMaybe<GqlTimeParameters>;
};

export type GqlMutationResetArgs = {
  id: Scalars['ID'];
};

export type GqlMutationSetBreakpointArgs = {
  breakpoint: GqlBreakpoint;
  id: Scalars['ID'];
};

export type GqlMutationSetSingleSteppingArgs = {
  enable: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type GqlMutationStartTxArgs = {
  id: Scalars['ID'];
  txJson: Scalars['String'];
};

export type GqlMutationSubmitArgs = {
  tx: Scalars['HexString'];
};

export type GqlNodeInfo = {
  __typename: 'NodeInfo';
  maxDepth: Scalars['U64'];
  maxTx: Scalars['U64'];
  minGasPrice: Scalars['U64'];
  nodeVersion: Scalars['String'];
  utxoValidation: Scalars['Boolean'];
  vmBacktrace: Scalars['Boolean'];
};

export type GqlOutput =
  | GqlChangeOutput
  | GqlCoinOutput
  | GqlContractCreated
  | GqlContractOutput
  | GqlMessageOutput
  | GqlVariableOutput;

/**
 * A separate `Breakpoint` type to be used as an output, as a single
 * type cannot act as both input and output type in async-graphql
 */
export type GqlOutputBreakpoint = {
  __typename: 'OutputBreakpoint';
  contract: Scalars['ContractId'];
  pc: Scalars['U64'];
};

/** Information about pagination in a connection */
export type GqlPageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type GqlPoAConsensus = {
  __typename: 'PoAConsensus';
  /** Gets the signature of the block produced by `PoA` consensus. */
  signature: Scalars['Signature'];
};

export type GqlProgramState = {
  __typename: 'ProgramState';
  data: Scalars['HexString'];
  returnType: GqlReturnType;
};

export type GqlQuery = {
  __typename: 'Query';
  balance: GqlBalance;
  balances: GqlBalanceConnection;
  block?: Maybe<GqlBlock>;
  blocks: GqlBlockConnection;
  chain: GqlChainInfo;
  /** Gets the coin by `utxo_id`. */
  coin?: Maybe<GqlCoin>;
  /**
   * Gets all coins of some `owner` maybe filtered with by `asset_id` per page.
   * It includes `CoinStatus::Spent` and `CoinStatus::Unspent` coins.
   */
  coins: GqlCoinConnection;
  contract?: Maybe<GqlContract>;
  contractBalance: GqlContractBalance;
  contractBalances: GqlContractBalanceConnection;
  /** Returns true when the GraphQL API is serving requests. */
  health: Scalars['Boolean'];
  memory: Scalars['String'];
  messageProof?: Maybe<GqlMessageProof>;
  messages: GqlMessageConnection;
  nodeInfo: GqlNodeInfo;
  register: Scalars['U64'];
  /**
   * For each `query_per_asset`, get some spendable resources(of asset specified by the query) owned by
   * `owner` that add up at least the query amount. The returned resources are actual resources
   * that can be spent. The number of resources is optimized to prevent dust accumulation.
   * Max number of resources and excluded resources can also be specified.
   *
   * Returns:
   * The list of spendable resources per asset from the query. The length of the result is
   * the same as the length of `query_per_asset`. The ordering of assets and `query_per_asset`
   * is the same.
   */
  resourcesToSpend: Array<Array<GqlResource>>;
  transaction?: Maybe<GqlTransaction>;
  transactions: GqlTransactionConnection;
  transactionsByOwner: GqlTransactionConnection;
};

export type GqlQueryBalanceArgs = {
  assetId: Scalars['AssetId'];
  owner: Scalars['Address'];
};

export type GqlQueryBalancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter: GqlBalanceFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GqlQueryBlockArgs = {
  height?: InputMaybe<Scalars['U64']>;
  id?: InputMaybe<Scalars['BlockId']>;
};

export type GqlQueryBlocksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GqlQueryCoinArgs = {
  utxoId: Scalars['UtxoId'];
};

export type GqlQueryCoinsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter: GqlCoinFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GqlQueryContractArgs = {
  id: Scalars['ContractId'];
};

export type GqlQueryContractBalanceArgs = {
  asset: Scalars['AssetId'];
  contract: Scalars['ContractId'];
};

export type GqlQueryContractBalancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter: GqlContractBalanceFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GqlQueryMemoryArgs = {
  id: Scalars['ID'];
  size: Scalars['U64'];
  start: Scalars['U64'];
};

export type GqlQueryMessageProofArgs = {
  messageId: Scalars['MessageId'];
  transactionId: Scalars['TransactionId'];
};

export type GqlQueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<Scalars['Address']>;
};

export type GqlQueryRegisterArgs = {
  id: Scalars['ID'];
  register: Scalars['U64'];
};

export type GqlQueryResourcesToSpendArgs = {
  excludedIds?: InputMaybe<GqlExcludeInput>;
  owner: Scalars['Address'];
  queryPerAsset: Array<GqlSpendQueryElementInput>;
};

export type GqlQueryTransactionArgs = {
  id: Scalars['TransactionId'];
};

export type GqlQueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GqlQueryTransactionsByOwnerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  owner: Scalars['Address'];
};

export type GqlReceipt = {
  __typename: 'Receipt';
  amount?: Maybe<Scalars['U64']>;
  assetId?: Maybe<Scalars['AssetId']>;
  contract?: Maybe<GqlContract>;
  contractId?: Maybe<Scalars['ContractId']>;
  data?: Maybe<Scalars['HexString']>;
  digest?: Maybe<Scalars['Bytes32']>;
  gas?: Maybe<Scalars['U64']>;
  gasUsed?: Maybe<Scalars['U64']>;
  is?: Maybe<Scalars['U64']>;
  len?: Maybe<Scalars['U64']>;
  messageId?: Maybe<Scalars['MessageId']>;
  nonce?: Maybe<Scalars['Bytes32']>;
  param1?: Maybe<Scalars['U64']>;
  param2?: Maybe<Scalars['U64']>;
  pc?: Maybe<Scalars['U64']>;
  ptr?: Maybe<Scalars['U64']>;
  ra?: Maybe<Scalars['U64']>;
  rawPayload: Scalars['HexString'];
  rb?: Maybe<Scalars['U64']>;
  rc?: Maybe<Scalars['U64']>;
  rd?: Maybe<Scalars['U64']>;
  reason?: Maybe<Scalars['U64']>;
  receiptType: GqlReceiptType;
  recipient?: Maybe<Scalars['Address']>;
  result?: Maybe<Scalars['U64']>;
  sender?: Maybe<Scalars['Address']>;
  to?: Maybe<GqlContract>;
  toAddress?: Maybe<Scalars['Address']>;
  val?: Maybe<Scalars['U64']>;
};

export enum GqlReceiptType {
  Call = 'CALL',
  Log = 'LOG',
  LogData = 'LOG_DATA',
  MessageOut = 'MESSAGE_OUT',
  Panic = 'PANIC',
  Return = 'RETURN',
  ReturnData = 'RETURN_DATA',
  Revert = 'REVERT',
  ScriptResult = 'SCRIPT_RESULT',
  Transfer = 'TRANSFER',
  TransferOut = 'TRANSFER_OUT',
}

/** The schema analog of the [`resource::Resource`]. */
export type GqlResource = GqlCoin | GqlMessage;

export enum GqlReturnType {
  Return = 'RETURN',
  ReturnData = 'RETURN_DATA',
  Revert = 'REVERT',
}

export type GqlRunResult = {
  __typename: 'RunResult';
  breakpoint?: Maybe<GqlOutputBreakpoint>;
  jsonReceipts: Array<Scalars['String']>;
  state: GqlRunState;
};

export enum GqlRunState {
  /** Stopped on a breakpoint */
  Breakpoint = 'BREAKPOINT',
  /** All breakpoints have been processed, and the program has terminated */
  Completed = 'COMPLETED',
}

export type GqlSpendQueryElementInput = {
  /** Target amount for the query. */
  amount: Scalars['U64'];
  /** Identifier of the asset to spend. */
  assetId: Scalars['AssetId'];
  /** The maximum number of currencies for selection. */
  max?: InputMaybe<Scalars['U64']>;
};

export type GqlSqueezedOutStatus = {
  __typename: 'SqueezedOutStatus';
  reason: Scalars['String'];
};

export type GqlSubmittedStatus = {
  __typename: 'SubmittedStatus';
  time: Scalars['Tai64Timestamp'];
};

export type GqlSubscription = {
  __typename: 'Subscription';
  /**
   * Returns a stream of status updates for the given transaction id.
   * If the current status is [`TransactionStatus::Success`], [`TransactionStatus::SqueezedOut`]
   * or [`TransactionStatus::Failed`] the stream will return that and end immediately.
   * If the current status is [`TransactionStatus::Submitted`] this will be returned
   * and the stream will wait for a future update.
   *
   * This stream will wait forever so it's advised to use within a timeout.
   *
   * It is possible for the stream to miss an update if it is polled slower
   * than the updates arrive. In such a case, the stream will close without
   * a status. If this occurs the stream can simply be restarted to return
   * the latest status.
   */
  statusChange: GqlTransactionStatus;
};

export type GqlSubscriptionStatusChangeArgs = {
  id: Scalars['TransactionId'];
};

export type GqlSuccessStatus = {
  __typename: 'SuccessStatus';
  block: GqlBlock;
  programState?: Maybe<GqlProgramState>;
  time: Scalars['Tai64Timestamp'];
};

export type GqlTimeParameters = {
  /** The time interval between subsequent blocks */
  blockTimeInterval: Scalars['U64'];
  /** The time to set on the first block */
  startTime: Scalars['U64'];
};

export type GqlTransaction = {
  __typename: 'Transaction';
  bytecodeLength?: Maybe<Scalars['U64']>;
  bytecodeWitnessIndex?: Maybe<Scalars['Int']>;
  gasLimit?: Maybe<Scalars['U64']>;
  gasPrice?: Maybe<Scalars['U64']>;
  id: Scalars['TransactionId'];
  inputAssetIds?: Maybe<Array<Scalars['AssetId']>>;
  inputContracts?: Maybe<Array<GqlContract>>;
  inputs?: Maybe<Array<GqlInput>>;
  isCreate: Scalars['Boolean'];
  isMint: Scalars['Boolean'];
  isScript: Scalars['Boolean'];
  maturity?: Maybe<Scalars['U64']>;
  outputs: Array<GqlOutput>;
  /** Return the transaction bytes using canonical encoding */
  rawPayload: Scalars['HexString'];
  receipts?: Maybe<Array<GqlReceipt>>;
  receiptsRoot?: Maybe<Scalars['Bytes32']>;
  salt?: Maybe<Scalars['Salt']>;
  script?: Maybe<Scalars['HexString']>;
  scriptData?: Maybe<Scalars['HexString']>;
  status?: Maybe<GqlTransactionStatus>;
  storageSlots?: Maybe<Array<Scalars['HexString']>>;
  txPointer?: Maybe<Scalars['TxPointer']>;
  witnesses?: Maybe<Array<Scalars['HexString']>>;
};

export type GqlTransactionConnection = {
  __typename: 'TransactionConnection';
  /** A list of edges. */
  edges: Array<GqlTransactionEdge>;
  /** A list of nodes. */
  nodes: Array<GqlTransaction>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlTransactionEdge = {
  __typename: 'TransactionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: GqlTransaction;
};

export type GqlTransactionStatus =
  | GqlFailureStatus
  | GqlSqueezedOutStatus
  | GqlSubmittedStatus
  | GqlSuccessStatus;

export type GqlVariableOutput = {
  __typename: 'VariableOutput';
  amount: Scalars['U64'];
  assetId: Scalars['AssetId'];
  to: Scalars['Address'];
};

export type GqlTransactionFragmentFragment = {
  __typename: 'Transaction';
  id: string;
  rawPayload: string;
  gasPrice?: string | null;
  status?:
    | {
        __typename: 'FailureStatus';
        time: any;
        reason: string;
        type: 'FailureStatus';
        block: { __typename: 'Block'; id: string };
      }
    | { __typename: 'SqueezedOutStatus'; type: 'SqueezedOutStatus' }
    | { __typename: 'SubmittedStatus'; time: any; type: 'SubmittedStatus' }
    | {
        __typename: 'SuccessStatus';
        time: any;
        type: 'SuccessStatus';
        block: { __typename: 'Block'; id: string };
        programState?: {
          __typename: 'ProgramState';
          returnType: GqlReturnType;
          data: string;
        } | null;
      }
    | null;
};

export type GqlReceiptFragmentFragment = {
  __typename: 'Receipt';
  data?: string | null;
  rawPayload: string;
};

export type GqlBlockFragmentFragment = {
  __typename: 'Block';
  id: string;
  header: { __typename: 'Header'; height: string; time: any };
  transactions: Array<{ __typename: 'Transaction'; id: string }>;
};

export type GqlCoinFragmentFragment = {
  __typename: 'Coin';
  utxoId: string;
  owner: string;
  amount: string;
  assetId: string;
  maturity: string;
  blockCreated: string;
  coinStatus: GqlCoinStatus;
};

export type GqlMessageFragmentFragment = {
  __typename: 'Message';
  amount: string;
  sender: string;
  recipient: string;
  data: string;
  nonce: string;
  daHeight: string;
  messageStatus: GqlMessageStatus;
};

export type GqlMessageProofFragmentFragment = {
  __typename: 'MessageProof';
  proofSet: Array<string>;
  proofIndex: string;
  sender: string;
  recipient: string;
  nonce: string;
  amount: string;
  data: string;
  signature: any;
  header: {
    __typename: 'Header';
    id: string;
    daHeight: string;
    transactionsCount: string;
    outputMessagesCount: string;
    transactionsRoot: string;
    outputMessagesRoot: string;
    height: string;
    prevRoot: string;
    time: any;
    applicationHash: string;
  };
};

export type GqlBalanceFragmentFragment = {
  __typename: 'Balance';
  owner: string;
  amount: string;
  assetId: string;
};

export type GqlConsensusParametersFragmentFragment = {
  __typename: 'ConsensusParameters';
  contractMaxSize: string;
  maxInputs: string;
  maxOutputs: string;
  maxWitnesses: string;
  maxGasPerTx: string;
  maxScriptLength: string;
  maxScriptDataLength: string;
  maxStorageSlots: string;
  maxPredicateLength: string;
  maxPredicateDataLength: string;
  gasPriceFactor: string;
  gasPerByte: string;
  maxMessageDataLength: string;
};

export type GqlChainInfoFragmentFragment = {
  __typename: 'ChainInfo';
  name: string;
  baseChainHeight: string;
  peerCount: number;
  consensusParameters: {
    __typename: 'ConsensusParameters';
    contractMaxSize: string;
    maxInputs: string;
    maxOutputs: string;
    maxWitnesses: string;
    maxGasPerTx: string;
    maxScriptLength: string;
    maxScriptDataLength: string;
    maxStorageSlots: string;
    maxPredicateLength: string;
    maxPredicateDataLength: string;
    gasPriceFactor: string;
    gasPerByte: string;
    maxMessageDataLength: string;
  };
  latestBlock: {
    __typename: 'Block';
    id: string;
    header: { __typename: 'Header'; height: string; time: any };
    transactions: Array<{ __typename: 'Transaction'; id: string }>;
  };
};

export type GqlContractBalanceFragmentFragment = {
  __typename: 'ContractBalance';
  contract: string;
  amount: string;
  assetId: string;
};

export type GqlGetVersionQueryVariables = Exact<{ [key: string]: never }>;

export type GqlGetVersionQuery = {
  __typename: 'Query';
  nodeInfo: { __typename: 'NodeInfo'; nodeVersion: string };
};

export type GqlGetInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GqlGetInfoQuery = {
  __typename: 'Query';
  nodeInfo: { __typename: 'NodeInfo'; nodeVersion: string; minGasPrice: string };
};

export type GqlGetChainQueryVariables = Exact<{ [key: string]: never }>;

export type GqlGetChainQuery = {
  __typename: 'Query';
  chain: {
    __typename: 'ChainInfo';
    name: string;
    baseChainHeight: string;
    peerCount: number;
    consensusParameters: {
      __typename: 'ConsensusParameters';
      contractMaxSize: string;
      maxInputs: string;
      maxOutputs: string;
      maxWitnesses: string;
      maxGasPerTx: string;
      maxScriptLength: string;
      maxScriptDataLength: string;
      maxStorageSlots: string;
      maxPredicateLength: string;
      maxPredicateDataLength: string;
      gasPriceFactor: string;
      gasPerByte: string;
      maxMessageDataLength: string;
    };
    latestBlock: {
      __typename: 'Block';
      id: string;
      header: { __typename: 'Header'; height: string; time: any };
      transactions: Array<{ __typename: 'Transaction'; id: string }>;
    };
  };
};

export type GqlGetTransactionQueryVariables = Exact<{
  transactionId: Scalars['TransactionId'];
}>;

export type GqlGetTransactionQuery = {
  __typename: 'Query';
  transaction?: {
    __typename: 'Transaction';
    id: string;
    rawPayload: string;
    gasPrice?: string | null;
    status?:
      | {
          __typename: 'FailureStatus';
          time: any;
          reason: string;
          type: 'FailureStatus';
          block: { __typename: 'Block'; id: string };
        }
      | { __typename: 'SqueezedOutStatus'; type: 'SqueezedOutStatus' }
      | { __typename: 'SubmittedStatus'; time: any; type: 'SubmittedStatus' }
      | {
          __typename: 'SuccessStatus';
          time: any;
          type: 'SuccessStatus';
          block: { __typename: 'Block'; id: string };
          programState?: {
            __typename: 'ProgramState';
            returnType: GqlReturnType;
            data: string;
          } | null;
        }
      | null;
  } | null;
};

export type GqlGetTransactionWithReceiptsQueryVariables = Exact<{
  transactionId: Scalars['TransactionId'];
}>;

export type GqlGetTransactionWithReceiptsQuery = {
  __typename: 'Query';
  transaction?: {
    __typename: 'Transaction';
    id: string;
    rawPayload: string;
    gasPrice?: string | null;
    receipts?: Array<{ __typename: 'Receipt'; data?: string | null; rawPayload: string }> | null;
    status?:
      | {
          __typename: 'FailureStatus';
          time: any;
          reason: string;
          type: 'FailureStatus';
          block: { __typename: 'Block'; id: string };
        }
      | { __typename: 'SqueezedOutStatus'; type: 'SqueezedOutStatus' }
      | { __typename: 'SubmittedStatus'; time: any; type: 'SubmittedStatus' }
      | {
          __typename: 'SuccessStatus';
          time: any;
          type: 'SuccessStatus';
          block: { __typename: 'Block'; id: string };
          programState?: {
            __typename: 'ProgramState';
            returnType: GqlReturnType;
            data: string;
          } | null;
        }
      | null;
  } | null;
};

export type GqlGetTransactionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GqlGetTransactionsQuery = {
  __typename: 'Query';
  transactions: {
    __typename: 'TransactionConnection';
    edges: Array<{
      __typename: 'TransactionEdge';
      node: {
        __typename: 'Transaction';
        id: string;
        rawPayload: string;
        gasPrice?: string | null;
        status?:
          | {
              __typename: 'FailureStatus';
              time: any;
              reason: string;
              type: 'FailureStatus';
              block: { __typename: 'Block'; id: string };
            }
          | { __typename: 'SqueezedOutStatus'; type: 'SqueezedOutStatus' }
          | { __typename: 'SubmittedStatus'; time: any; type: 'SubmittedStatus' }
          | {
              __typename: 'SuccessStatus';
              time: any;
              type: 'SuccessStatus';
              block: { __typename: 'Block'; id: string };
              programState?: {
                __typename: 'ProgramState';
                returnType: GqlReturnType;
                data: string;
              } | null;
            }
          | null;
      };
    }>;
  };
};

export type GqlGetTransactionsByOwnerQueryVariables = Exact<{
  owner: Scalars['Address'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GqlGetTransactionsByOwnerQuery = {
  __typename: 'Query';
  transactionsByOwner: {
    __typename: 'TransactionConnection';
    edges: Array<{
      __typename: 'TransactionEdge';
      node: {
        __typename: 'Transaction';
        id: string;
        rawPayload: string;
        gasPrice?: string | null;
        status?:
          | {
              __typename: 'FailureStatus';
              time: any;
              reason: string;
              type: 'FailureStatus';
              block: { __typename: 'Block'; id: string };
            }
          | { __typename: 'SqueezedOutStatus'; type: 'SqueezedOutStatus' }
          | { __typename: 'SubmittedStatus'; time: any; type: 'SubmittedStatus' }
          | {
              __typename: 'SuccessStatus';
              time: any;
              type: 'SuccessStatus';
              block: { __typename: 'Block'; id: string };
              programState?: {
                __typename: 'ProgramState';
                returnType: GqlReturnType;
                data: string;
              } | null;
            }
          | null;
      };
    }>;
  };
};

export type GqlGetBlockQueryVariables = Exact<{
  blockId?: InputMaybe<Scalars['BlockId']>;
  blockHeight?: InputMaybe<Scalars['U64']>;
}>;

export type GqlGetBlockQuery = {
  __typename: 'Query';
  block?: {
    __typename: 'Block';
    id: string;
    header: { __typename: 'Header'; height: string; time: any };
    transactions: Array<{ __typename: 'Transaction'; id: string }>;
  } | null;
};

export type GqlGetBlockWithTransactionsQueryVariables = Exact<{
  blockId?: InputMaybe<Scalars['BlockId']>;
  blockHeight?: InputMaybe<Scalars['U64']>;
}>;

export type GqlGetBlockWithTransactionsQuery = {
  __typename: 'Query';
  block?: {
    __typename: 'Block';
    id: string;
    transactions: Array<{
      __typename: 'Transaction';
      id: string;
      rawPayload: string;
      gasPrice?: string | null;
      status?:
        | {
            __typename: 'FailureStatus';
            time: any;
            reason: string;
            type: 'FailureStatus';
            block: { __typename: 'Block'; id: string };
          }
        | { __typename: 'SqueezedOutStatus'; type: 'SqueezedOutStatus' }
        | { __typename: 'SubmittedStatus'; time: any; type: 'SubmittedStatus' }
        | {
            __typename: 'SuccessStatus';
            time: any;
            type: 'SuccessStatus';
            block: { __typename: 'Block'; id: string };
            programState?: {
              __typename: 'ProgramState';
              returnType: GqlReturnType;
              data: string;
            } | null;
          }
        | null;
    }>;
    header: { __typename: 'Header'; height: string; time: any };
  } | null;
};

export type GqlGetBlocksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GqlGetBlocksQuery = {
  __typename: 'Query';
  blocks: {
    __typename: 'BlockConnection';
    edges: Array<{
      __typename: 'BlockEdge';
      node: {
        __typename: 'Block';
        id: string;
        header: { __typename: 'Header'; height: string; time: any };
        transactions: Array<{ __typename: 'Transaction'; id: string }>;
      };
    }>;
  };
};

export type GqlGetCoinQueryVariables = Exact<{
  coinId: Scalars['UtxoId'];
}>;

export type GqlGetCoinQuery = {
  __typename: 'Query';
  coin?: {
    __typename: 'Coin';
    utxoId: string;
    owner: string;
    amount: string;
    assetId: string;
    maturity: string;
    blockCreated: string;
    coinStatus: GqlCoinStatus;
  } | null;
};

export type GqlGetCoinsQueryVariables = Exact<{
  filter: GqlCoinFilterInput;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GqlGetCoinsQuery = {
  __typename: 'Query';
  coins: {
    __typename: 'CoinConnection';
    edges: Array<{
      __typename: 'CoinEdge';
      node: {
        __typename: 'Coin';
        utxoId: string;
        owner: string;
        amount: string;
        assetId: string;
        maturity: string;
        blockCreated: string;
        coinStatus: GqlCoinStatus;
      };
    }>;
  };
};

export type GqlGetResourcesToSpendQueryVariables = Exact<{
  owner: Scalars['Address'];
  queryPerAsset: Array<GqlSpendQueryElementInput> | GqlSpendQueryElementInput;
  excludedIds?: InputMaybe<GqlExcludeInput>;
}>;

export type GqlGetResourcesToSpendQuery = {
  __typename: 'Query';
  resourcesToSpend: Array<
    Array<
      | {
          __typename: 'Coin';
          utxoId: string;
          owner: string;
          amount: string;
          assetId: string;
          maturity: string;
          blockCreated: string;
          coinStatus: GqlCoinStatus;
        }
      | {
          __typename: 'Message';
          amount: string;
          sender: string;
          recipient: string;
          data: string;
          nonce: string;
          daHeight: string;
          messageStatus: GqlMessageStatus;
        }
    >
  >;
};

export type GqlGetContractQueryVariables = Exact<{
  contractId: Scalars['ContractId'];
}>;

export type GqlGetContractQuery = {
  __typename: 'Query';
  contract?: { __typename: 'Contract'; bytecode: string; id: string } | null;
};

export type GqlGetContractBalanceQueryVariables = Exact<{
  contract: Scalars['ContractId'];
  asset: Scalars['AssetId'];
}>;

export type GqlGetContractBalanceQuery = {
  __typename: 'Query';
  contractBalance: {
    __typename: 'ContractBalance';
    contract: string;
    amount: string;
    assetId: string;
  };
};

export type GqlGetBalanceQueryVariables = Exact<{
  owner: Scalars['Address'];
  assetId: Scalars['AssetId'];
}>;

export type GqlGetBalanceQuery = {
  __typename: 'Query';
  balance: { __typename: 'Balance'; owner: string; amount: string; assetId: string };
};

export type GqlGetBalancesQueryVariables = Exact<{
  filter: GqlBalanceFilterInput;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GqlGetBalancesQuery = {
  __typename: 'Query';
  balances: {
    __typename: 'BalanceConnection';
    edges: Array<{
      __typename: 'BalanceEdge';
      node: { __typename: 'Balance'; owner: string; amount: string; assetId: string };
    }>;
  };
};

export type GqlGetMessagesQueryVariables = Exact<{
  owner: Scalars['Address'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GqlGetMessagesQuery = {
  __typename: 'Query';
  messages: {
    __typename: 'MessageConnection';
    edges: Array<{
      __typename: 'MessageEdge';
      node: {
        __typename: 'Message';
        amount: string;
        sender: string;
        recipient: string;
        data: string;
        nonce: string;
        daHeight: string;
        messageStatus: GqlMessageStatus;
      };
    }>;
  };
};

export type GqlGetMessageProofQueryVariables = Exact<{
  transactionId: Scalars['TransactionId'];
  messageId: Scalars['MessageId'];
}>;

export type GqlGetMessageProofQuery = {
  __typename: 'Query';
  messageProof?: {
    __typename: 'MessageProof';
    proofSet: Array<string>;
    proofIndex: string;
    sender: string;
    recipient: string;
    nonce: string;
    amount: string;
    data: string;
    signature: any;
    header: {
      __typename: 'Header';
      id: string;
      daHeight: string;
      transactionsCount: string;
      outputMessagesCount: string;
      transactionsRoot: string;
      outputMessagesRoot: string;
      height: string;
      prevRoot: string;
      time: any;
      applicationHash: string;
    };
  } | null;
};

export type GqlDryRunMutationVariables = Exact<{
  encodedTransaction: Scalars['HexString'];
  utxoValidation?: InputMaybe<Scalars['Boolean']>;
}>;

export type GqlDryRunMutation = {
  __typename: 'Mutation';
  dryRun: Array<{ __typename: 'Receipt'; data?: string | null; rawPayload: string }>;
};

export type GqlSubmitMutationVariables = Exact<{
  encodedTransaction: Scalars['HexString'];
}>;

export type GqlSubmitMutation = {
  __typename: 'Mutation';
  submit: { __typename: 'Transaction'; id: string };
};

export type GqlStartSessionMutationVariables = Exact<{ [key: string]: never }>;

export type GqlStartSessionMutation = { __typename: 'Mutation'; startSession: string };

export type GqlEndSessionMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;

export type GqlEndSessionMutation = { __typename: 'Mutation'; endSession: boolean };

export type GqlExecuteMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  op: Scalars['String'];
}>;

export type GqlExecuteMutation = { __typename: 'Mutation'; execute: boolean };

export type GqlResetMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;

export type GqlResetMutation = { __typename: 'Mutation'; reset: boolean };

export const TransactionFragmentFragmentDoc = gql`
  fragment transactionFragment on Transaction {
    id
    rawPayload
    gasPrice
    status {
      type: __typename
      ... on SubmittedStatus {
        time
      }
      ... on SuccessStatus {
        block {
          id
        }
        time
        programState {
          returnType
          data
        }
      }
      ... on FailureStatus {
        block {
          id
        }
        time
        reason
      }
    }
  }
`;
export const ReceiptFragmentFragmentDoc = gql`
  fragment receiptFragment on Receipt {
    data
    rawPayload
  }
`;
export const CoinFragmentFragmentDoc = gql`
  fragment coinFragment on Coin {
    utxoId
    owner
    amount
    assetId
    maturity
    coinStatus: status
    blockCreated
  }
`;
export const MessageFragmentFragmentDoc = gql`
  fragment messageFragment on Message {
    amount
    sender
    recipient
    data
    nonce
    messageStatus: status
    daHeight
  }
`;
export const MessageProofFragmentFragmentDoc = gql`
  fragment messageProofFragment on MessageProof {
    proofSet
    proofIndex
    sender
    recipient
    nonce
    amount
    data
    signature
    header {
      id
      daHeight
      transactionsCount
      outputMessagesCount
      transactionsRoot
      outputMessagesRoot
      height
      prevRoot
      time
      applicationHash
    }
  }
`;
export const BalanceFragmentFragmentDoc = gql`
  fragment balanceFragment on Balance {
    owner
    amount
    assetId
  }
`;
export const ConsensusParametersFragmentFragmentDoc = gql`
  fragment consensusParametersFragment on ConsensusParameters {
    contractMaxSize
    maxInputs
    maxOutputs
    maxWitnesses
    maxGasPerTx
    maxScriptLength
    maxScriptDataLength
    maxStorageSlots
    maxPredicateLength
    maxPredicateDataLength
    gasPriceFactor
    gasPerByte
    maxMessageDataLength
  }
`;
export const BlockFragmentFragmentDoc = gql`
  fragment blockFragment on Block {
    id
    header {
      height
      time
    }
    transactions {
      id
    }
  }
`;
export const ChainInfoFragmentFragmentDoc = gql`
  fragment chainInfoFragment on ChainInfo {
    name
    baseChainHeight
    peerCount
    consensusParameters {
      ...consensusParametersFragment
    }
    latestBlock {
      ...blockFragment
    }
  }
  ${ConsensusParametersFragmentFragmentDoc}
  ${BlockFragmentFragmentDoc}
`;
export const ContractBalanceFragmentFragmentDoc = gql`
  fragment contractBalanceFragment on ContractBalance {
    contract
    amount
    assetId
  }
`;
export const GetVersionDocument = gql`
  query getVersion {
    nodeInfo {
      nodeVersion
    }
  }
`;
export const GetInfoDocument = gql`
  query getInfo {
    nodeInfo {
      nodeVersion
      minGasPrice
    }
  }
`;
export const GetChainDocument = gql`
  query getChain {
    chain {
      ...chainInfoFragment
    }
  }
  ${ChainInfoFragmentFragmentDoc}
`;
export const GetTransactionDocument = gql`
  query getTransaction($transactionId: TransactionId!) {
    transaction(id: $transactionId) {
      ...transactionFragment
    }
  }
  ${TransactionFragmentFragmentDoc}
`;
export const GetTransactionWithReceiptsDocument = gql`
  query getTransactionWithReceipts($transactionId: TransactionId!) {
    transaction(id: $transactionId) {
      ...transactionFragment
      receipts {
        ...receiptFragment
      }
    }
  }
  ${TransactionFragmentFragmentDoc}
  ${ReceiptFragmentFragmentDoc}
`;
export const GetTransactionsDocument = gql`
  query getTransactions($after: String, $before: String, $first: Int, $last: Int) {
    transactions(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          ...transactionFragment
        }
      }
    }
  }
  ${TransactionFragmentFragmentDoc}
`;
export const GetTransactionsByOwnerDocument = gql`
  query getTransactionsByOwner(
    $owner: Address!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    transactionsByOwner(owner: $owner, after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          ...transactionFragment
        }
      }
    }
  }
  ${TransactionFragmentFragmentDoc}
`;
export const GetBlockDocument = gql`
  query getBlock($blockId: BlockId, $blockHeight: U64) {
    block(id: $blockId, height: $blockHeight) {
      ...blockFragment
    }
  }
  ${BlockFragmentFragmentDoc}
`;
export const GetBlockWithTransactionsDocument = gql`
  query getBlockWithTransactions($blockId: BlockId, $blockHeight: U64) {
    block(id: $blockId, height: $blockHeight) {
      ...blockFragment
      transactions {
        ...transactionFragment
      }
    }
  }
  ${BlockFragmentFragmentDoc}
  ${TransactionFragmentFragmentDoc}
`;
export const GetBlocksDocument = gql`
  query getBlocks($after: String, $before: String, $first: Int, $last: Int) {
    blocks(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          ...blockFragment
        }
      }
    }
  }
  ${BlockFragmentFragmentDoc}
`;
export const GetCoinDocument = gql`
  query getCoin($coinId: UtxoId!) {
    coin(utxoId: $coinId) {
      ...coinFragment
    }
  }
  ${CoinFragmentFragmentDoc}
`;
export const GetCoinsDocument = gql`
  query getCoins(
    $filter: CoinFilterInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    coins(filter: $filter, after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          ...coinFragment
        }
      }
    }
  }
  ${CoinFragmentFragmentDoc}
`;
export const GetResourcesToSpendDocument = gql`
  query getResourcesToSpend(
    $owner: Address!
    $queryPerAsset: [SpendQueryElementInput!]!
    $excludedIds: ExcludeInput
  ) {
    resourcesToSpend(owner: $owner, queryPerAsset: $queryPerAsset, excludedIds: $excludedIds) {
      ...coinFragment
      ...messageFragment
    }
  }
  ${CoinFragmentFragmentDoc}
  ${MessageFragmentFragmentDoc}
`;
export const GetContractDocument = gql`
  query getContract($contractId: ContractId!) {
    contract(id: $contractId) {
      bytecode
      id
    }
  }
`;
export const GetContractBalanceDocument = gql`
  query getContractBalance($contract: ContractId!, $asset: AssetId!) {
    contractBalance(contract: $contract, asset: $asset) {
      ...contractBalanceFragment
    }
  }
  ${ContractBalanceFragmentFragmentDoc}
`;
export const GetBalanceDocument = gql`
  query getBalance($owner: Address!, $assetId: AssetId!) {
    balance(owner: $owner, assetId: $assetId) {
      ...balanceFragment
    }
  }
  ${BalanceFragmentFragmentDoc}
`;
export const GetBalancesDocument = gql`
  query getBalances(
    $filter: BalanceFilterInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    balances(filter: $filter, after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          ...balanceFragment
        }
      }
    }
  }
  ${BalanceFragmentFragmentDoc}
`;
export const GetMessagesDocument = gql`
  query getMessages($owner: Address!, $after: String, $before: String, $first: Int, $last: Int) {
    messages(owner: $owner, after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          ...messageFragment
        }
      }
    }
  }
  ${MessageFragmentFragmentDoc}
`;
export const GetMessageProofDocument = gql`
  query getMessageProof($transactionId: TransactionId!, $messageId: MessageId!) {
    messageProof(transactionId: $transactionId, messageId: $messageId) {
      ...messageProofFragment
    }
  }
  ${MessageProofFragmentFragmentDoc}
`;
export const DryRunDocument = gql`
  mutation dryRun($encodedTransaction: HexString!, $utxoValidation: Boolean) {
    dryRun(tx: $encodedTransaction, utxoValidation: $utxoValidation) {
      ...receiptFragment
    }
  }
  ${ReceiptFragmentFragmentDoc}
`;
export const SubmitDocument = gql`
  mutation submit($encodedTransaction: HexString!) {
    submit(tx: $encodedTransaction) {
      id
    }
  }
`;
export const StartSessionDocument = gql`
  mutation startSession {
    startSession
  }
`;
export const EndSessionDocument = gql`
  mutation endSession($sessionId: ID!) {
    endSession(id: $sessionId)
  }
`;
export const ExecuteDocument = gql`
  mutation execute($sessionId: ID!, $op: String!) {
    execute(id: $sessionId, op: $op)
  }
`;
export const ResetDocument = gql`
  mutation reset($sessionId: ID!) {
    reset(id: $sessionId)
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getVersion(
      variables?: GqlGetVersionQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetVersionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetVersionQuery>(GetVersionDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getVersion',
        'query'
      );
    },
    getInfo(
      variables?: GqlGetInfoQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetInfoQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetInfoQuery>(GetInfoDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getInfo',
        'query'
      );
    },
    getChain(
      variables?: GqlGetChainQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetChainQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetChainQuery>(GetChainDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getChain',
        'query'
      );
    },
    getTransaction(
      variables: GqlGetTransactionQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetTransactionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetTransactionQuery>(GetTransactionDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getTransaction',
        'query'
      );
    },
    getTransactionWithReceipts(
      variables: GqlGetTransactionWithReceiptsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetTransactionWithReceiptsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetTransactionWithReceiptsQuery>(
            GetTransactionWithReceiptsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getTransactionWithReceipts',
        'query'
      );
    },
    getTransactions(
      variables?: GqlGetTransactionsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetTransactionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetTransactionsQuery>(GetTransactionsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getTransactions',
        'query'
      );
    },
    getTransactionsByOwner(
      variables: GqlGetTransactionsByOwnerQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetTransactionsByOwnerQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetTransactionsByOwnerQuery>(
            GetTransactionsByOwnerDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getTransactionsByOwner',
        'query'
      );
    },
    getBlock(
      variables?: GqlGetBlockQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetBlockQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetBlockQuery>(GetBlockDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getBlock',
        'query'
      );
    },
    getBlockWithTransactions(
      variables?: GqlGetBlockWithTransactionsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetBlockWithTransactionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetBlockWithTransactionsQuery>(
            GetBlockWithTransactionsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getBlockWithTransactions',
        'query'
      );
    },
    getBlocks(
      variables?: GqlGetBlocksQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetBlocksQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetBlocksQuery>(GetBlocksDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getBlocks',
        'query'
      );
    },
    getCoin(
      variables: GqlGetCoinQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetCoinQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetCoinQuery>(GetCoinDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getCoin',
        'query'
      );
    },
    getCoins(
      variables: GqlGetCoinsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetCoinsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetCoinsQuery>(GetCoinsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getCoins',
        'query'
      );
    },
    getResourcesToSpend(
      variables: GqlGetResourcesToSpendQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetResourcesToSpendQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetResourcesToSpendQuery>(GetResourcesToSpendDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getResourcesToSpend',
        'query'
      );
    },
    getContract(
      variables: GqlGetContractQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetContractQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetContractQuery>(GetContractDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getContract',
        'query'
      );
    },
    getContractBalance(
      variables: GqlGetContractBalanceQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetContractBalanceQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetContractBalanceQuery>(GetContractBalanceDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getContractBalance',
        'query'
      );
    },
    getBalance(
      variables: GqlGetBalanceQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetBalanceQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetBalanceQuery>(GetBalanceDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getBalance',
        'query'
      );
    },
    getBalances(
      variables: GqlGetBalancesQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetBalancesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetBalancesQuery>(GetBalancesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getBalances',
        'query'
      );
    },
    getMessages(
      variables: GqlGetMessagesQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetMessagesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetMessagesQuery>(GetMessagesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getMessages',
        'query'
      );
    },
    getMessageProof(
      variables: GqlGetMessageProofQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlGetMessageProofQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlGetMessageProofQuery>(GetMessageProofDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getMessageProof',
        'query'
      );
    },
    dryRun(
      variables: GqlDryRunMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlDryRunMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlDryRunMutation>(DryRunDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'dryRun',
        'mutation'
      );
    },
    submit(
      variables: GqlSubmitMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlSubmitMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlSubmitMutation>(SubmitDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'submit',
        'mutation'
      );
    },
    startSession(
      variables?: GqlStartSessionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlStartSessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlStartSessionMutation>(StartSessionDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'startSession',
        'mutation'
      );
    },
    endSession(
      variables: GqlEndSessionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlEndSessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlEndSessionMutation>(EndSessionDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'endSession',
        'mutation'
      );
    },
    execute(
      variables: GqlExecuteMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlExecuteMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlExecuteMutation>(ExecuteDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'execute',
        'mutation'
      );
    },
    reset(
      variables: GqlResetMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GqlResetMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GqlResetMutation>(ResetDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'reset',
        'mutation'
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
